<template>
    <b-collapse class="longContent" id="collapse_long" >
        <CloseButton v-b-toggle.collapse_long></CloseButton>
        <div role="tablist" class="headers" >
            <div role="tab" class="tabs">
                <section class="header education-header"  v-b-toggle.accordion-1  tabindex="0" >
                    <h2>Education</h2>
                    <article class="text">
                        <p>...what I've learned</p>
                    </article>
                </section>
                <b-collapse class="education" id="accordion-1" accordion="my-accordion">
                    <EduTimeline>

                    </EduTimeline>
                </b-collapse>
            </div>
            <div role="tab" >
                <section  class="header experience-header" v-b-toggle.accordion-2  tabindex="0">
                    <h2>Experience</h2>
                    <article class="text">
                        <p>...what I've done</p>
                    </article>
                </section>
                <b-collapse class="experience" id="accordion-2"  accordion="my-accordion">
                    <ExpTimeline/>
                </b-collapse>
            </div>
            <div role="tab" >
                <section class="header skills-header" v-b-toggle.accordion-3 tabindex="0" v-scroll-to="'#accordion-3'">
                    <h2>Skills</h2>
                    <article class="text">
                        <p>...what I can do</p>
                    </article>
                </section>
                <b-collapse class="skills" id="accordion-3" accordion="my-accordion">
                    <Skills/>
                </b-collapse>
            </div>
        </div>
    </b-collapse>
</template>

<script>
    import EduTimeline from "./EduTimeline";
    import ExpTimeline from "./ExpTimeline";
    import Skills from "./Skills";
    import CloseButton from "../CloseButton";
    export default {
        name: "LongContent",
        components: {CloseButton, ExpTimeline, EduTimeline, Skills}
    }

</script>

<style scoped>
    .longContent {
        background: lightblue;
        height: auto;
        position: relative;
        min-height: 100vh;
    }
    section {
        width: 100%;
        height: 33.33vh;
        outline: none;
        cursor: pointer;
    }
    .text {
        display: flex;
        justify-content: center;
        align-items: center;
        height: 100%;
    }

    .education-header {
        background-image: url("../../assets/edu.jpg");
        background-size: cover;
        background-position: center bottom;
    }
    .education {
        background: linear-gradient(to bottom, #0083B0, #1CB5E0);
    }
    .experience-header {
        background-image: url("../../assets/kb.jpg");
        background-size: cover;
        background-position: center;
    }
    .experience {
        background: linear-gradient(to bottom, #1CB5E0, #004e92);
    }
    .skills-header{
        background-image: url("../../assets/skills.jpg");
        background-size: cover;
        background-position: center;
    }
    .skills {
        background: linear-gradient(to bottom, #004e92, #000428);

    }

    h2 {
        font-size: 3.5vmax;
        color: white;
        text-shadow: 0 0 8px blue;
        text-align: center;
        font-weight: 700;
        padding-top: 100px;

    }
    .text {
        height: 30px;
        font-size: 2vmax;
        color: white;
        padding-left: 70px;
        padding-top: 20px;
        text-shadow: 0 0 8px yellow;
        font-weight: 600;
    }

</style>